import React, { useState } from "react";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  alphabet,
  email,
  phoneNumber,
  alphaNumericPattern,
} from "../core/regex";
import { postContactForm } from "../../redux/Actions";

const contactFormSchema = yup.object({
  name: yup
    .string()
    .required("Full name is required")
    .max(50, "Enter cannot exceed 50 character")
    .matches(alphabet, "Name should be only alphabet")
    .trim(),
  email: yup
    .string()
    .required("Email address is required")
    .matches(email, "Enter a valid email address")
    .max(96, "Enter cannot exceed 96 character")
    .trim(),
  mobile: yup
    .string()
    .required("Phone number is required")
    .matches(phoneNumber, "Enter a valid phone number")
    .trim(),
  message: yup
    .string()
    .required("Message is required")
    .matches(
      alphaNumericPattern,
      "Message cannot contain any special character"
    )
    .max(250, "Message cannot exceed 250 character")
    .trim(),
});

function SectionContactThemeFive() {
  const [message, setMessage] = useState<string>("");
  const [isError, setIsError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(contactFormSchema),
    defaultValues: {
      name: "",
      email: "",
      mobile: "",
      message: "",
    },
  });

  const submitContactForm = async (data: any) => {
    setLoading(true);
    try {
      const response: any = await postContactForm(data);
      if (response && response.status) {
        setIsError(false);
        setMessage(response.message);
        reset();
      } else {
        setIsError(true);
        setMessage(response?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setIsError(true);
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 4000);
    }
  };

  return (
    <div className="contact-section-five" id="contact">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center aos-init" data-aos="fade-down">
              <h2>Get In Touch</h2>
              <p>Send us your queries and we will get back to you shortly.</p>
            </div>
            <div className="contact-card-five">
              <form onSubmit={handleSubmit(submitContactForm)}>
                <div className="form-group-five">
                  <label>Full Name</label>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="text"
                        placeholder="Full Name"
                        {...field}
                        className={`form-control ${errors?.name ? "invalid" : ""}`}
                      />
                    )}
                  />
                  {errors.name ? (
                    <small className="text-danger">{errors.name?.message}</small>
                  ) : null}
                </div>

                <div className="form-group-five">
                  <label>Email Address</label>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="text"
                        placeholder="Email Address"
                        {...field}
                        className={`form-control ${errors?.email ? "invalid" : ""}`}
                      />
                    )}
                  />
                  {errors.email ? (
                    <small className="text-danger">{errors.email?.message}</small>
                  ) : null}
                </div>

                <div className="form-group-five">
                  <label>Phone number</label>
                  <Controller
                    name="mobile"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="text"
                        placeholder="Phone number"
                        {...field}
                        onFocus={e => {
                          if (!field.value) {
                            field.onChange("+44 ");
                          }
                        }}
                        className={`form-control ${errors?.mobile ? "invalid" : ""}`}
                      />
                    )}
                  />
                  {errors.mobile ? (
                    <small className="text-danger">{errors.mobile?.message}</small>
                  ) : null}
                </div>

                {/* <div className="form-group-five">
                  <label>Subject</label>
                  <Controller
                    name="subject"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="text"
                        placeholder="Subject"
                        {...field}
                        className={`form-control ${errors?.subject ? "invalid" : ""}`}
                      />
                    )}
                  />
                  {errors.subject ? (
                    <small className="text-danger">{errors.subject?.message}</small>
                  ) : null}
                </div> */}

                <div className="form-group-five">
                  <label>Your Message</label>
                  <Controller
                    name="message"
                    control={control}
                    render={({ field }) => (
                      <textarea
                        rows={4}
                        placeholder="Your Message"
                        {...field}
                        className={`form-control ${errors?.message ? "invalid" : ""}`}
                      ></textarea>
                    )}
                  />
                  {errors.message ? (
                    <small className="text-danger">{errors.message?.message}</small>
                  ) : null}
                </div>

                {message != "" ? (
                  <div className="form-group-five">
                    <small className={isError ? "text-danger" : "text-success"}>
                      {message}
                    </small>
                  </div>
                ) : null}

                <div className="contact-btn-wrap">
                  <button
                    type="submit"
                    className="contact-btn-five"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Contact us"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionContactThemeFive;
